import React, { Component } from 'react';
import Products from './Products';
import Header from './Header';
import Footer from './Footer';
import Client from "shopify-buy";
import {withRouter} from 'react-router';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import {FormattedMessage} from "react-intl";
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';
import {Col, Row} from "reactstrap";
import * as validator from 'email-validator';
import { AiOutlineMail } from 'react-icons/ai';

export const client = Client.buildClient({
    storefrontAccessToken: '8ca8cb5f4a81756952c5994d52462f2c',
    domain: 'dr-brauwolf.myshopify.com',
});

class User extends Component {

    constructor() {
        super();

        this.state = {
            isCartOpen: false,
            checkout: { lineItems: [] },
            products: [],
            shop: {},
            heroContent: '',
            sent: false,
            email: '',
            error: ''
        };

        this.handleCartClose = this.handleCartClose.bind(this);
        this.addVariantToCart = this.addVariantToCart.bind(this);
        this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
        this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleMagicLinkRequest = this.handleMagicLinkRequest.bind(this);
    }

    componentWillMount()
    {
        if(!localStorage.getItem('checkoutId'))
        {
            client.checkout.create().then((res) => {
                this.setState({
                    checkout: res,
                });
                // setter
                localStorage.setItem('checkoutId', res.id);
            });
        }
        else
        {
            const checkoutId = localStorage.getItem('checkoutId');
            client.checkout.fetch(checkoutId).then((res) => {

                if(res == null || res.order)
                {
                    localStorage.clear();
                    client.checkout.create().then((res) => {
                        this.setState({
                            checkout: res,
                        });
                        // setter
                        localStorage.setItem('checkoutId', res.id);
                    });

                }
                else {
                    this.setState({
                        checkout: res,
                    });
                }
            });
        }

        client.collection.fetchAllWithProducts().then((collections) => {

            var collectionAlcohol =  collections.filter(c => c.title == "Dr. Brauwolf - Regular")[0].products;
            var collectionNoAlcohol =  collections.filter(c => c.title == "Dr. Brauwolf - Alkoholfrei")[0].products;
            var collectionSpecial =  collections.filter(c => c.title == "Dr. Brauwolf - Beer of the Month")[0].products;
            var collectionShirts =  collections.filter(c => c.title == "Dr. Brauwolf - Sonstiges")[0].products;
            var collectionGiftcard = collections.filter(c => c.title == "Dr. Brauwolf - Geschenkkarte")[0].products;

            var unfilteredProducts = collectionAlcohol.concat(collectionSpecial).concat(collectionNoAlcohol).concat(collectionShirts).concat(collectionGiftcard);
            // var filteredProducts = [];
            // unfilteredProducts.forEach(product => {
            //     if(product.tags != null && product.tags.length > 0) {
            //         var tags = product.tags.map(tag => tag.value);
            //         if (!tags.includes("deactivated")) {
            //             filteredProducts.push(product);
            //         }
            //     }
            // });
            this.setState({
                products: unfilteredProducts,
            });
        });

        client.shop.fetchInfo().then((res) => {
            this.setState({
                shop: res,
            });
        });

        var finalLocale = 'en';
        var locale = require('browser-locale')();
        if(locale == null) {
            //console.log('no locale');
        }
        else {
            var localePrefix = locale.substring(0,2);

            if(localePrefix === 'de' || localePrefix === 'fr' || localePrefix === 'it')
            {
                finalLocale = localePrefix + '-CH';
            }
        }

        const cookies = new Cookies();
        if(!cookies.get('ls_lang'))
        {
            cookies.set('checkout_locale', finalLocale, {path: '/'});
            cookies.set('ls_lang', finalLocale, {path: '/'});
        }
    }

    handleScriptCreate() {
        this.setState({ scriptLoaded: false })
    }

    handleScriptError() {
        this.setState({ scriptError: true })
    }

    handleScriptLoad() {
        this.setState({ scriptLoaded: true })
    }

    addVariantToCart(variantId, quantity){

        // Add to Cart Button Effect
        //------------------------------------------------------------------------------
        $('.shop-item').each(function() {

            if(this.id === variantId)
            {
                var animating = false;

                var addToCartBtn = $(this).find('.add-to-cart');

                if(!animating) {
                    //animate if not already animating
                    animating =  true;
                    // resetCustomization(addToCartBtn);
                    addToCartBtn.addClass('is-added').find('path').eq(0).animate({
                        //draw the check icon
                        'stroke-dashoffset':0
                    }, 300, function(){
                        setTimeout(function(){
                            // updateCart();
                            addToCartBtn.removeClass('is-added').find('em').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
                                //wait for the end of the transition to reset the check icon
                                addToCartBtn.find('path').eq(0).css('stroke-dashoffset', '19.79');
                                animating =  false;
                            });

                            if( $('.no-csstransitions').length > 0 ) {
                                // check if browser doesn't support css transitions
                                addToCartBtn.find('path').eq(0).css('stroke-dashoffset', '19.79');
                                animating =  false;
                            }
                        }, 600);
                    });
                }
            }
        });

        this.setState({
            isCartOpen: true,
        });

        const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}];
        const checkoutId = this.state.checkout.id;

        // console.log("adding variant in home");
        // let count = this.state.checkout.lineItems.map((line_item) => {return line_item.quantity;}).reduce(function(a,b) {return a+b;},0) + quantity;
        // let discountCode = "";
        // if(count == 1)
        // {
        //     //Removes the applied discount from an existing checkout.
        //     client.checkout.removeDiscount(this.state.checkout.id).then(checkout => {
        //         console.log("removed discount");
        //     });
        // }
        // else if(count == 2)
        // {
        //     discountCode = 'DM7A2CR4DFP4';
        // }
        // else if(count == 3)
        // {
        //     discountCode = 'R86XDV0Z6S68';
        // }
        // else if(count == 4)
        // {
        //     discountCode = 'N7GYCT233BEY';
        // }
        // else if(count == 5)
        // {
        //     discountCode = 'D7JYFRYS6GSS';
        // }
        //
        // if(discountCode != "" && this.state.checkout.discountApplications)
        // {
        //     if (this.state.checkout.discountApplications.length == 0 && count > 1)
        //     {
        //         client.checkout.addDiscount(this.state.checkout.id, discountCode).then(checkout =>
        //         {
        //             console.log("added new discount", discountCode);
        //         });
        //     }
        //     else
        //     {
        //         if(this.state.checkout.discountApplications[0] != null && this.state.checkout.discountApplications[0].code != discountCode)
        //         {
        //             client.checkout.addDiscount(this.state.checkout.id, discountCode).then(checkout =>
        //             {
        //                 console.log("added new discount", discountCode);
        //             });
        //         }
        //     }
        // }

        return client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    updateQuantityInCart(lineItemId, quantity) {
        const checkoutId = this.state.checkout.id
        const lineItemsToUpdate = [{id: lineItemId, quantity: parseInt(quantity, 10)}]

        return client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    removeLineItemInCart(lineItemId) {
        const checkoutId = this.state.checkout.id

        return client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    handleCartClose() {
        this.setState({
            isCartOpen: false,
        });
    }

    getBackendUrl()
    {
        let environment = process.env.NODE_ENV;

        // development
        let backendUrl = "http://localhost:9000/";
        // production
        if(environment == 'production')
            backendUrl = "https://admin.vatia.ch/";
        // test
        else if(environment == 'test')
            backendUrl = "https://admin.vatia.ch/";

        return backendUrl;
    }

    async handleMagicLinkRequest()
    {
        if(this.state.email == '')
        {
            this.setState({error: "Please provide an email address"});
            return;
        }
        else {
            if(validator.validate(this.state.email) == false)
            {
                this.setState({error: "Please provide a valid email address"});
                return;
            }
        }

        const options = {
            method: 'POST',
            url: this.getBackendUrl()+'vatia/login/magiclink/de',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
            data: {
                email: this.state.email,
                vendorname: "Dr. Brauwolf",
                vendoremail: "info@drbrauwolf.ch"
            }
        };

        let result = await axios.request(options)
        .then(response => {return true})
        .catch(error => {console.log("error", error); return false});

        console.log("result", result);

        if(result == true)
            this.setState({sent: true});
        else
            this.setState({error: "Couldn't process login request. Please try again later or contact us via email."});
    }

    handleEmailChange(e) {
        this.setState({ email: e.currentTarget.value });
    }

    render() {

        document.onkeydown = checkKey;

        function checkKey(e) {

            e = e || window.event;

            if (e.keyCode == '38') {
                // up arrow
            }
            else if (e.keyCode == '40') {
                // down arrow
            }
            else if (e.keyCode == '37') {
                // left arrow
                document.querySelector('.owl-prev').click();
            }
            else if (e.keyCode == '39') {
                // right arrow
                document.querySelector('.owl-next').click();
            }

            else if (e.keyCode == '13') {
                document.querySelector('.active').querySelector('.detail').click();
            }

            else if (e.keyCode == '27') {
                document.querySelector('.scroll-to-top-btn').click();
            }

        }

        return (
            <div className="App">
                <Header
                    products={this.state.products}
                    checkout={this.state.checkout}
                    isCartOpen={this.state.isCartOpen}
                    handleCartClose={this.handleCartClose}
                    updateQuantityInCart={this.updateQuantityInCart}
                    removeLineItemInCart={this.removeLineItemInCart}
                />
                <section className="container padding-top padding-bottom">
                    <Row style={{paddingTop:35, paddingBottom:50, minHeight:500}}>
                        <Col style={{textAlign:"center"}}>
                            <h1>Login - Subscription</h1>
                            {this.state.sent == false ? <>
                                <p style={{paddingTop:10, paddingBottom:10}}>Please provide the email address<br/> you have used for your subscription.</p>
                            {this.state.error != "" ? <><span style={{color:"red", paddingBottom:7, display:"inline-block", maxWidth:350}}>{this.state.error}</span><br/></> : null}
                            <input onInput={this.handleEmailChange} autoComplete={"email"} id="email" type="email" placeholder="Your email" style={{minWidth:300, marginRight:10, height:37,
                                borderRadius: 5, marginTop:0, padding: 10,
                                border:this.state.email == "" ? "2px solid black" : this.state.error != "" ? "2px solid red" : "2px solid green"}} required/>
                            <button style={{backgroundColor:"#f19800",border:0,borderRadius:4,color:"#fff",
                                padding:6, marginTop:-4, width: 100, height: 38, fontSize: 12, fontWeight: 600}} onClick={() => this.handleMagicLinkRequest()}>
                                {this.state.sent == false ? 'Continue' : 'Request sent'}
                            </button>
                            </> :
                            <>
                            <AiOutlineMail size={48}/>
                                <p>Please check your mailbox, <br/>we have sent you a link.</p>
                            </>}
                        </Col>
                    </Row>
                </section>
                <Footer/>
            </div>
        );
    }
}

export default withRouter(User)
